import React from "react";

function CloseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="29"
      viewBox="0 0 29 29"
    >
      <g
        id="Group_31053"
        data-name="Group 31053"
        transform="translate(-1765 -1347)"
      >
        <circle
          id="Ellipse_1991"
          data-name="Ellipse 1991"
          cx="14.5"
          cy="14.5"
          r="14.5"
          transform="translate(1765 1347)"
          fill="#596970"
        />
        <path
          id="Path_19904"
          data-name="Path 19904"
          d="M11.609,10.282l4.646-4.646,1.327,1.327L12.936,11.61l4.646,4.646-1.327,1.327-4.646-4.646L6.963,17.583,5.636,16.255l4.646-4.646L5.636,6.964,6.963,5.637Z"
          transform="translate(1768.042 1349.527)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default CloseIcon;
